import React, { Component } from "react";
import PropTypes from "prop-types";
import Button from "@p1s/p1s-common-react/Button";
import TextInput from "../../controls/TextInput";
import { isEnterPressed } from "../../utilities/EventsHelper";
import ValidationHelper from "../../utilities/ValidationHelper";

class SetEmailForm extends Component {
    constructor (props) {
        super(props);

        this.state = {
            error: false
        };
        this.handleEnterKey = this.handleEnterKey.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.onEmailChanged = this.onEmailChanged.bind(this);
    }


    handleEnterKey (e) {
        if (isEnterPressed(e)) {
            this.sendEmail();
        }
    }

    sendEmail () {
        var email = this.props.email;
        if (this.isValidEmailFormat(email)) {
            this.props.sendEmail(email);
        }
        else {
            this.setState({ error: true });
        }
    }

    onEmailChanged (event) {
        this.setState({ error: false });
        this.props.onEmailChanged(event.target.value.trim());
    }

    isValidEmailFormat (value) {
        return ValidationHelper.isValidEmailFormat(value);
    }

    render () {
        const email = this.props.email;
        const hasError = this.state.error;
        const isEnabled = this.isValidEmailFormat(email);
        const hideSkipLink = this.props.hideSkipLink;

        return (
            <div id="setEmailPage">
                <div className="form-title">Upgrade Your SoleSource Account</div>
                <div className="form-subtitle">We’re making big changes to your account security, sign in, and account management experience,
                    along with new features that will only be accessible with an email-linked account.
                    Once you’ve upgraded, you will be able to log in with your email address.
                </div>

                <div className="form-subtitle">To upgrade, follow these 3 steps:</div>

                <table className="stepsTable">
                    <tbody>
                        <tr>
                            <td className="steps-icon"><span className="material-icon-keyboard-variant"/></td>
                            <td className="steps-text">Enter your email address below</td>
                        </tr>
                        <tr>
                            <td className="icon-separator"><span>|</span></td>
                            <td className="steps-text" />
                        </tr>
                        <tr>
                            <td className="steps-icon"><span className="ion-android-mail"/></td>
                            <td className="steps-text">We'll send you a verification email</td>
                        </tr>
                        <tr>
                            <td className="icon-separator"><span>|</span></td>
                            <td className="steps-text" />
                        </tr>
                        <tr>
                            <td className="steps-icon"><span className="ion-mouse"/></td>
                            <td className="steps-text">Click on the verification button in the email</td>
                        </tr>
                    </tbody>
                </table>

                <div className="enter-email-title">Enter email to upgrade</div>
                <div className="email-row">
                    <TextInput tabIndex={1} onKeyUp={this.handleEnterKey}
                        placeholder={"Email address"} onChange={this.onEmailChanged}
                        inputClassName={"picker-hollow"} value={email}
                    />
                </div>
                <div className="button-container">
                    <Button id="bSendEmailIn" disabled={!isEnabled}
                        className="btn btn-primary-action pull-right"
                        tabIndex="2"
                        onClick={this.sendEmail}>Send Verification Email</Button>
                </div>

                <div role="alert"
                    id="loginErrorMessage"
                    className={ hasError ? "show-block" : "hide" }>
                    <span className="alertSummaryText">{"Please enter correct email."}</span>
                </div>

                <div className={ ["skipLink", (hideSkipLink ? "hide" : "show-block")].join(" ") }
                    name="skipLink">
                    <a href={this.props.skipUrl}>Skip for Now</a>
                </div>

            </div>
        );
    }
}

SetEmailForm.defaultProps ={
    email: ""
};

SetEmailForm.propTypes = {
    sendEmail: PropTypes.func,
    skipUrl: PropTypes.string,
    email: PropTypes.string,
    onEmailChanged: PropTypes.func,
    hideSkipLink: PropTypes.bool
};

export default SetEmailForm;
